import { CONTRACT_TYPE } from "constants/contractTypeEnum";

export const isAveragePricingContract = (type: string) =>
  type === CONTRACT_TYPE.AVERAGE_PRICING;
export const isDelayedPricingContract = (type: string) =>
  type === CONTRACT_TYPE.DELAYED_PRICING;
export const isForwardContract = (type: string) =>
  type === CONTRACT_TYPE.FORWARD_PRICING;
